/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldEnum } from './FieldEnum';
import { FieldEnumFromJSON, FieldEnumFromJSONTyped, FieldEnumToJSON } from './FieldEnum';

/**
 *
 * @export
 * @interface TextFieldTemplate
 */
export interface TextFieldTemplate {
  /**
   *
   * @type {number}
   * @memberof TextFieldTemplate
   */
  readonly id: number;
  /**
   *
   * @type {FieldEnum}
   * @memberof TextFieldTemplate
   */
  field: FieldEnum;
  /**
   *
   * @type {string}
   * @memberof TextFieldTemplate
   */
  template: string;
}

/**
 * Check if a given object implements the TextFieldTemplate interface.
 */
export function instanceOfTextFieldTemplate(value: object): value is TextFieldTemplate {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('field' in value) || value['field'] === undefined) return false;
  if (!('template' in value) || value['template'] === undefined) return false;
  return true;
}

export function TextFieldTemplateFromJSON(json: any): TextFieldTemplate {
  return TextFieldTemplateFromJSONTyped(json, false);
}

export function TextFieldTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextFieldTemplate {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    field: FieldEnumFromJSON(json['field']),
    template: json['template'],
  };
}

export function TextFieldTemplateToJSON(value?: Omit<TextFieldTemplate, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    field: FieldEnumToJSON(value['field']),
    template: value['template'],
  };
}
